import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { jsx, jsxs } from 'react/jsx-runtime.js';
import { useState, useEffect } from 'react';
import { Theme } from '../../ThemeContext.js';
import { handlePositiveKeyDown } from '../../../utils/keyboard.js';
import { ReactComponent as SvgCrescent } from '../../../media/images/crescent.svg.js';
import { ReactComponent as SvgSun } from '../../../media/images/sun.svg.js';
import styles from './ThemeToggle.module.css.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var ThemeToggle = function ThemeToggle(props) {
  var _props$defaultChecked = props.defaultChecked,
    defaultChecked = _props$defaultChecked === void 0 ? false : _props$defaultChecked,
    _props$htmlProps = props.htmlProps,
    htmlProps = _props$htmlProps === void 0 ? {} : _props$htmlProps,
    onChange = props.onChange;
  var _useState = useState(defaultChecked),
    _useState2 = _slicedToArray(_useState, 2),
    switchedOn = _useState2[0],
    setSwitchedOn = _useState2[1];
  var switchToggle = function switchToggle() {
    setSwitchedOn(!switchedOn);
    if (onChange) {
      onChange(!switchedOn ? Theme.dark : Theme.light);
    }
  };
  var handleKeyDown = function handleKeyDown(e) {
    handlePositiveKeyDown(e, switchToggle);
    if (e.key === 'a') {
      alert('Theme will be synced with system');
      onChange && onChange(Theme.auto);
    }
  };
  useEffect(function () {
    setSwitchedOn(defaultChecked);
  }, [defaultChecked]);
  return jsx("span", _objectSpread(_objectSpread({
    className: styles.checkbox,
    onClick: switchToggle,
    onKeyDown: handleKeyDown,
    role: "switch",
    "aria-checked": switchedOn,
    "aria-label": 'toggle dark theme',
    tabIndex: 0
  }, htmlProps), {}, {
    children: jsxs("span", {
      className: styles.helper,
      tabIndex: -1,
      children: [jsx("span", {
        className: "".concat(styles.switch, " ").concat(switchedOn ? styles.on : '')
      }), jsxs("div", {
        className: styles.iconContainer,
        children: [jsx(SvgSun, {
          className: styles.sunIcon
        }), jsx(SvgCrescent, {
          className: styles.crescentIcon
        })]
      })]
    })
  }));
};

export { ThemeToggle };
